import React from 'react';

import {MaybeCoreObject} from 'app-core/framework/CoreObjectConstants';
import {ProcessPlatformFeatureType} from 'graphql-client/__generated/graphqlGlobalTypes';
import {getProcessPlatformFeatureConfig} from 'processes/processes-platform/FeatureOptions';
import EditableStudiesList from 'studies/studyable/EditableStudiesList';

import {
  ProcessTaskDetailsRowContent,
  ProcessTaskGql,
  getProcessTaskDetailsLabels,
} from '../ProcessTaskDetailsPageConstants';

export default function getStudiesRowContent(processTask: ProcessTaskGql): ProcessTaskDetailsRowContent {
  return {
    label: getProcessTaskDetailsLabels().STUDIES,
    component: (
      <EditableStudiesList
        studyable={processTask as MaybeCoreObject}
        isWritable={
          processTask.permissions.writable &&
          getProcessPlatformFeatureConfig(
            ProcessPlatformFeatureType.CAN_EDIT_STUDIES_METADATA,
            processTask.schema.executionType,
            processTask.schema.name
          )
        }
      />
    ),
  };
}
